import { Map, MapMarker } from "react-kakao-maps-sdk"
import useKakaoLoader from "../../views/pages/common/useKakaoLoader"
import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

export default function KakaoMap(props) {
    useKakaoLoader()
    const center = {
        // 지도의 중심좌표
        lat: props?.lat,
        lng: props?.lng,
    }

    return (
        <>
            <PC>
                <Map // 지도를 표시할 Container
                    id="map"
                    center={{
                        // 지도의 중심좌표
                        lat: 37.7560753,
                        lng: 127.0229565,
                    }}
                    style={{
                        // 지도의 크기
                        width: "100%",
                        height: "350px",
                    }}
                    level={3} // 지도의 확대 레벨
                >
                    <MapMarker position={center} />
                </Map>
            </PC>
            <Notebook>
                <Map // 지도를 표시할 Container
                    id="map"
                    center={{
                        // 지도의 중심좌표
                        lat: 37.7560753,
                        lng: 127.0229565,
                    }}
                    style={{
                        // 지도의 크기
                        width: "100%",
                        height: "350px",
                    }}
                    level={3} // 지도의 확대 레벨
                >
                    <MapMarker position={center} />
                </Map>
            </Notebook>
            <Tablet>
                <Map // 지도를 표시할 Container
                    id="map"
                    center={{
                        // 지도의 중심좌표
                        lat: 37.7560753,
                        lng: 127.0229565,
                    }}
                    style={{
                        // 지도의 크기
                        width: "100%",
                        height: "300px",
                    }}
                    level={3} // 지도의 확대 레벨
                >
                    <MapMarker position={center} />
                </Map>
            </Tablet>
            <Mobile>
                <Map // 지도를 표시할 Container
                    id="map"
                    center={{
                        // 지도의 중심좌표
                        lat: 37.7560753,
                        lng: 127.0229565,
                    }}
                    style={{
                        // 지도의 크기
                        width: "100%",
                        height: "300px",
                    }}
                    level={3} // 지도의 확대 레벨
                >
                    <MapMarker position={center} />
                </Map>
            </Mobile>
        </>
    )
}
